import $http from '@/api/http'

// 获取全部计划批次
export function getAllProjectNotic(data){
    return $http({
        url:'/xmt/common/getAllProjectNotic',
        method:'get',
        data
    })
}
// 获取申报详情
export function details(data){
    return $http({
        url:'/xmt/hundredDeclare/details',
        method:'get',
        data
    })
}
// 批量审核接口
export function batchExamine(data){
    return $http({
        url:'/xmt/hundredDeclare/batchExamine',
        method:'post',
        data
    })
}
// 单个创新审核接口
export function innovateExamine(data){
    return $http({
        url:'/xmt/hundredDeclare/innovateExamine',
        method:'post',
        data
    })
}
// 申报审核回显暂存
export function stagingEcho(data){
    return $http({
        url:'/xmt/hundredDeclare/stagingEcho',
        method:'get',
        data
    })
}
// 申报审核结果详情
export function reviewDetail(data){
    return $http({
        url:'/xmt/hundredDeclare/reviewDetail',
        method:'get',
        data
    })
}
// 上传附件接口
export function uploadFile(data){
    return $http({
        url:`/xmt/common/upload`,
        method:'post',
        data
    })
}
// 删除附件
export function deleteFile(params){
    return $http({
        url:`/xmt/common/delFile`,
        method:'post',
        params
    })
}
// 上传申报表
export function uploadDeclareAtt(data){
    return $http({
        url:`/xmt/hundredInformation/uploadDeclareAtt`,
        method:'post',
        data
    })
}
// 下载申报表
export function downloadDeclareAtt(data){
    return $http({
        url:`/xmt/hundredInformation/downloadDeclareAtt`,
        method:'get',
        data
    })
}
// 导出zip 下载全部附件
export function exportZip(data) {
    return $http({
        url: '/xmt/common/exportZip',
        method: 'post',
        responseType: 'blob',
        contentType: 'application/json;charset=utf-8',
        data
    })
}
// 区走访意见
export function getDistrictVisitComments(data) {
    return $http({
        url: '/xmt/review/getDistrictVisitComments',
        method: 'post',
        data
    })
}
// 获取考察意见，考察材料
export function selectSurvey(data){
    return $http({
        url:'/xmt/hundredDeclare/selectSurvey',
        method:'get',
        data
    })
}
// 删除申报
export function cancelDelDeclaration(params){
    return $http({
        url:`/xmt/hundredDeclare/delDeclaration`,
        method:'post',
        params:params
    })
}
// 撤销申报
export function undoApplication(params){
    return $http({
        url:`/xmt/hundredInformation/cancelApplication`,
        method:'post',
        params:params
    })
}
// 发起修改申请
export function initiateModifyApply(data){
    return $http({
        url:`/xmt/hundredInformation/initiateModifyApply`,
        method:'post',
        data:data
    })
}

// 上传答辩材料
export function uploadReply(data){
    return $http({
        url:`/xmt/hundredInformation/uploadReply`,
        method:'post',
        data:data
    })
}

// 校验数据是否撤销
export function checkIsCancel(data){
    return $http({
        url:`/xmt/hundredDeclare/checkMsgDeclaration`,
        method:'get',
        data
    })
}

// 在线预览查看
export function docOnlineView(data){
    return $http({
        url:`/xmt/hundredInformation/docOnlineView`,
        method:'post',
        data:data
    })
}